import { DatePipe } from "@angular/common";
import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { Status } from "../../models/status";
import { ImportserialService } from "../../services/importserial.service";
import { AccountsTransactionType } from "src/app/finance/constants/constants";

@Component({
  selector: "app-purchase-order-overview",
  templateUrl: "./purchase-order-overview.component.html",
  styleUrls: ["./purchase-order-overview.component.scss"],
})
export class PurchaseOrderOverviewComponent implements OnInit, OnChanges {

  @Input() poDetails;
  length: number =0;
  qtyDecimal: number =0;
  baseCurrency: any;
  ordersVendorAddr = "";
  ordersVendorCity = "";
  ordersVendorState = "";
  ordersVendorCountry = "";
  ordersVendorZipcode = "";
  ordersVendorPhone;
  ordersVendorAddrNew = "";
  ordersVendorCityNew = "";
  ordersVendorStateNew = "";
  ordersVendorCountryNew = "";
  ordersVendorZipcodeNew = "";
  ordersVendorPhoneNew;
  purchase_billing: any[] = [];
  purchase_shipping: any[] = [];
  purchase_misc: any[] = [];
  purchase_section: any[] = [];
  purchase_table: any[] = [];
  purchase_footer: any[] = [];
  purchase_message: any[] = [];
  purchase_other1: any[] = [];
  purchase_other2: any[] = [];
  purchase_other3: any[] = [];
  allTax;
  taxEnabled;
  poTemplate;
  purchaseListTB;
  allLocationsDD = [];
  allLocations = [];
  shipAddress;
  transactionTypeIds = AccountsTransactionType;
  glApiCall: boolean = false;
  poId: number;
  @Input() visibleFromModule;
  lineTotal: number = 0;
  footerTaxEnabled: boolean = false;

  constructor(
    public app: AppMainComponent,
    private purchaseService: PurchasesService,
    private datePipe: DatePipe,
    private appMainService: AppMainService,private importService: ImportserialService
  ) { }

  ngOnInit(): void {
    this.importService.getDecimalValue().subscribe(value => {
      if(value){
        this.length = value;
      }
    })
    this.importService.getQtyDecimalValue().subscribe(value => {
      if(value){
        this.qtyDecimal = value;
      }
    })
    this.importService.getOrgCurrency().subscribe(value => {
      if(value){
        this.baseCurrency = value.find(cr=> cr.isBaseCurrency);
      }
    })
    this.getAllTax();
    this.getAllLocations();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.poDetails?.currentValue) {
      this.poDetails = changes.poDetails.currentValue;
      this.poId = this.poDetails?.id;
      this.parsePoDetails();
    }
  }

  parsePoDetails() {
    this.allLocationsDD = this.allLocations?.filter(
      (loc) => loc.statusId == Status.Active
    );
    if (this.poDetails.configJson != "") {
      this.poTemplate = JSON.parse(this.poDetails.configJson);
      if(this.poTemplate?.labels_table[5]?.isChecked){
        this.footerTaxEnabled = false;
      }else{
        this.footerTaxEnabled = true;
      }
    }
   
    /**Calculate prices based on Vendor Currency Exchange Rate**/
    this.poDetails.totalAmount =  Number(this.poDetails?.totalAmount) * Number(this.poDetails?.exchangeRate);
    this.poDetails.shippingAmount =  Number(this.poDetails?.shippingAmount) * Number(this.poDetails?.exchangeRate);
    this.poDetails.discountAmount =  Number(this.poDetails?.discountAmount) * Number(this.poDetails?.exchangeRate);
    this.poDetails.netAmount =  Number(this.poDetails?.netAmount) * Number(this.poDetails?.exchangeRate);
    this.poDetails.taxAmount =  Number(this.poDetails?.taxAmount) * Number(this.poDetails?.exchangeRate)
    const purchaseList = [];
    if (this.poDetails.purchaseOrderProducts.length > 0) {
      for (let l of this.poDetails.purchaseOrderProducts) {
        const bundleProducts: any[] = [];
        if (l.purchaseBundleDetail?.length > 0) {
          for (let prd of l.purchaseBundleDetail) {
            let eachProduct = {
              id: prd.id,
              productId: prd.productId,
              subProductId: prd.subProductId,
              purchaseOrderProductId: prd.purchaseOrderProductId,
              itemNo: prd.product?.itemNo,
              typeId: 4,
              description: prd.product?.description,
              availabel: prd.quantity,
              quantityPending: prd.qtyPending,
              quantityReceived: prd.qtyReceived,
              currentVal: prd.quantity,
              uom: prd.product?.productUOM
                .filter(
                  (uom) =>
                    uom.unitOfMeasureId == prd.productUnitId
                )
                .map((x) => x.uomDetail?.name)[0],
              totalAmount: parseFloat(prd.totalAmount).toFixed(this.length),
              pricePerProduct: parseFloat(
                prd.pricePerProduct
              ).toFixed(this.length),
              tax: this.allTax
                .filter((tax) => tax.id == prd.taxId)
                .map((x) => x.name)[0],
              discountType: prd.discountType?.description,
              discountAmount: prd.discountAmount,
            };
            bundleProducts.push(eachProduct);
          }
        }
        let eachProduct = {
          id: l.id,
          itemNo: l.product?.itemNo,
          description: l?.description,
          uom: l.product.productUOM
            .filter((uom) => uom.unitOfMeasureId == l.productUnitId)
            .map((x) => x.uomDetail?.name)[0],
          quantity: l.quantity,
          quantityPending: l.qtyPending,
          quantityReceived: l.qtyReceived,
          totalAmount: (Number(l.totalAmount) * Number(this.poDetails?.exchangeRate)).toFixed(this.length),
          netAmount: (Number(l.netAmount) * Number(this.poDetails?.exchangeRate)).toFixed(this.length),
          pricePerProduct: (Number(l.pricePerProduct)* Number(this.poDetails?.exchangeRate)).toFixed(this.length),
          tax: l.tax?.name,
          taxAmount: l.purchaseOrderProductSubTax?.reduce((sum, s) => sum + (Number(s.taxAmount) * this.poDetails?.exchangeRate), 0).toFixed(this.length),
          discountAmount: l.discountAmount,
          discountType: l.discountType?.description,
          typeId: bundleProducts.length > 0 ? 4 : 0,
          purchaseOrderProductId: l.id,
          products: bundleProducts,
        };
        purchaseList.push(eachProduct);
      }
    }
    this.purchaseListTB = purchaseList;
    this.lineTotal = this.purchaseListTB?.reduce((sum, s) => sum + Number(s.netAmount), 0);
    const inActiveWarehouse = this.allLocationsDD?.filter(
      (l) => l.id == this.poDetails?.warehouseId
    )[0];
    if (!inActiveWarehouse) {
      this.allLocationsDD.push(this.poDetails?.warehouse);
    }
    const filteredLocation = this.allLocationsDD?.filter(
      (l) => l.id == this.poDetails?.warehouseId
    )[0];
    this.getShipAddress(filteredLocation, true);
    if (this.poDetails.billingAddress) {
      this.ordersVendorAddr =
        this.poDetails.billingAddress.streetAddress1 == ""
          ? this.poDetails.billingAddress.streetAddress2
          : this.poDetails.billingAddress.streetAddress1;
      this.ordersVendorCity = this.poDetails.billingAddress.city?.name;
      this.ordersVendorState = this.poDetails.billingAddress.state?.name;
      this.ordersVendorCountry =
        this.poDetails.billingAddress.country?.name;
      this.ordersVendorZipcode = this.poDetails.billingAddress.zipCode;
    }

    //saved custom
    this.purchase_billing.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name !=
        "MultipleDropDownList"
      ) {
        element.value = filteredCustom.multipleValues;
      }
    });
    this.purchase_shipping.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name !=
        "MultipleDropDownList"
      ) {
        element.value = filteredCustom.multipleValues;
      }
    });
    this.purchase_misc.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
    this.purchase_section.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
    this.purchase_footer.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
    this.purchase_message.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
    this.purchase_other1.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
    this.purchase_other2.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
    this.purchase_other3.forEach((element) => {
      const filteredCustom = this.poDetails.customAttributeValues.filter(
        (c) => c.customAttributeId == element.id
      )[0];
      if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "InputBox"
      ) {
        element.value = filteredCustom.value;
      } else if (
        filteredCustom &&
        (filteredCustom.customAttribute?.formControl?.name ==
          "FileUpload" ||
          filteredCustom.customAttribute?.formControl?.name ==
          "Picture")
      ) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach((el) => {
          element.customUploadedFiles.push(el);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DatePicker"
      ) {
        element.value = this.datePipe.transform(
          filteredCustom.value,
          "MM/dd/yyyy"
        );
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "Rating"
      ) {
        element.value = filteredCustom.ratingId;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "ToggleButton"
      ) {
        element.value = filteredCustom.toggle;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "DropDownList"
      ) {
        element.value = filteredCustom.values;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "RadioButton"
      ) {
        element.value = filteredCustom.values.name;
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name == "CheckBox"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el.name);
        });
      } else if (
        filteredCustom &&
        filteredCustom.customAttribute?.formControl?.name ==
        "MultipleDropDownList"
      ) {
        element.value = [];
        filteredCustom.multipleValues.forEach((el) => {
          element.value.push(el);
        });
      }
    });
  }

  getShipAddress(location, action?) {
    this.shipAddress = location;
    if (!action) {
      // this.panel.hide();
    }
  }

  getAllTax() {
    this.appMainService.isShowSpinner("tax");
    this.purchaseService.getAllTax().subscribe((res) => {
      this.appMainService.isHideSpinner("tax");
      this.taxEnabled = res.item1;
      if (res.item1) {
        this.allTax = res.item2;
      }
    });
  }

  getAllLocations() {
    this.appMainService.isShowSpinner("locations");
    this.purchaseService.getAllLocations().subscribe((locations) => {
      this.appMainService.isHideSpinner("locations");
      for (let loc of locations) {
        loc.customName = loc.name + " - " + loc.locationId;
      }
      this.allLocations = locations;
    });
  }

  onTabChange(event){
    if(event.index == 1){
        this.glApiCall = true;
    }
    else{
        this.glApiCall = false;
    }
  }
}
